import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { BaseMediaClientError } from '../../models/errors';
export var PollingError = /*#__PURE__*/function (_BaseMediaClientError) {
  function PollingError(reason, metadata) {
    _classCallCheck(this, PollingError);
    return _callSuper(this, PollingError, [reason, metadata, undefined]);
  }

  // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
  /** Will be deprecated. Use the properties `reason` and `metadata` instead */
  _inherits(PollingError, _BaseMediaClientError);
  return _createClass(PollingError, [{
    key: "attributes",
    get: function get() {
      var reason = this.reason,
        attempts = this.metadata.attempts;
      return {
        reason: reason,
        attempts: attempts
      };
    }
  }]);
}(BaseMediaClientError);
export function isPollingError(err) {
  return err instanceof PollingError;
}